(function(w, $) {
    w.popup = function (options) {
        var isRenderLocked = false;
        var shouldOpenPopupAfterUnlock = false;

        var onClose = function () {
            const $this = $(this);

            if (options.canBeClosedByUser) {
                let $popup = $this.find('.js-popup');
                if (!$popup || !$popup.length) {
                    $popup = $this[0].$message.find('.js-popup');
                }

                const popupId = $popup.data('popupid');

                const $dontShowCheckbox = $popup.find('.js-dont-show-popup');
                const dontShowExplicit = $dontShowCheckbox.length > 0 && $dontShowCheckbox.is(':checked');

                $.ajax({
                    url: w.R + 'handlers/public/userdata.ashx',
                    type: 'POST',
                    data: {
                        action: 'StorePopupDisplaySettings',
                        popupId: popupId,
                        dontShowExplicit: dontShowExplicit
                    },
                    dataType: 'json',
                })
                    .done(function () {
                        console.log('Popup \'' +
                            popupId +
                            '\' display registered' +
                            (dontShowExplicit ? ' (don\'t show any more based on user selection)' : ''));
                    });
            }

            if (options.type === 'ModalBox') {
                $this.dialog('destroy').remove(); // https://stackoverflow.com/questions/4740500/jquery-dialog-dialog-fields-added-multiple-times-to-the-dom
            }
        };

        var fnOpenPopup;
        switch (options.type) {
            case 'ModalBox':
                fnOpenPopup = (function () {
                    const dialogOptions = {
                        title: options.title,
                        resizable: true,
                        draggable: true,
                        modal: true,
                        autoOpen: true,
                        width: options.width || 700,
                        close: onClose,
                        // For jQueryUI >= 1.12
                        classes: {
                            'ui-dialog': ['umw-popup-modal', options.classes].join(' '),
                            'ui-dialog-titlebar': 'umw-popup-modal-titlebar',
                            'ui-dialog-title': 'umw-popup-modal-title',
                            'ui-dialog-titlebar-close': 'umw-popup-modal-close',
                            'ui-dialog-content': 'umw-popup-modal-body'
                        },
                        // For jQueryUI < 1.12
                        dialogClass: ['umw-popup-modal', options.classes].join(' ')
                    };

                    if (!options.canBeClosedByUser) {
                        dialogOptions.closeOnEscape = false;
                        dialogOptions.open = function (event, ui) {
                            $('.ui-dialog-titlebar-close', ui.dialog | ui).hide();
                        };
                    }

                    $(options.content).dialog(dialogOptions);
                    reportPopupShown();
                });
                break;
            case 'Notification':
                fnOpenPopup = (function () {
                    // https://ned.im/noty/v2/options.html
                    var notyOptions = {
                        layout: 'bottomRight',
                        type: 'notification',
                        force: true,
                        closeWith: options.canBeClosedByUser ? ['button'] : [],
                        text: options.content,
                        template: '<div class="noty_message"><h3 class="noty_title"></h3><span class="noty_text"></span><div class="noty_close"></div></div>',
                        callback: {
                            onShow: function () {
                                if (options.title) {
                                    this.$bar.find('.noty_title').text(options.title);
                                }

                                this.$bar.addClass(['umw-popup-noty', options.classes].join(' '));
                            },
                            onClose: onClose
                        }
                    };

                    w.noty(notyOptions);
                    reportPopupShown();
                });
                break;
            default:
                return;
        }

        if (options.delay)
            w.setTimeout(function () {
                if (isRenderLocked) {
                    shouldOpenPopupAfterUnlock = true;
                } else {
                    fnOpenPopup();
                }
            }, options.delay);
        else
            fnOpenPopup();

        function reportPopupShown() {
            w.PubSub.publish('popup.shown', { popupId: options.popupId });
        }

        w.PubSub.subscribe('popup.lockRender', function () { isRenderLocked = true; });
        w.PubSub.subscribe('popup.unlockRender', function () {
            isRenderLocked = false;
            if (shouldOpenPopupAfterUnlock) {
                shouldOpenPopupAfterUnlock = false;
                fnOpenPopup();
            }
        });
    };
})(window, jQuery);